import React, { useEffect, useState, Suspense, lazy, Component } from 'react';
import { Hero } from './components/Hero';
import { useMetaPixel } from './components/useMetaPixel';
const BelowFold = lazy(() => import('./components/BelowFold').then(({
  BelowFold: Component
}) => ({
  default: Component
})));
export function App() {
  const [isBelowFoldReady, setIsBelowFoldReady] = useState(false);
  const [shouldScrollToPurchase, setShouldScrollToPurchase] = useState(false);
  useMetaPixel();
  useEffect(() => {
    const revealBelowFold = () => setIsBelowFoldReady(true);
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(revealBelowFold, {
        timeout: 1200
      });
      return;
    }
    const timerId = window.setTimeout(revealBelowFold, 500);
    return () => window.clearTimeout(timerId);
  }, []);
  useEffect(() => {
    if (!isBelowFoldReady || !shouldScrollToPurchase) return;
    let frameId = 0;
    let attempts = 0;
    const scrollWhenReady = () => {
      const purchaseSection = document.getElementById('planes');
      if (purchaseSection) {
        purchaseSection.scrollIntoView({
          behavior: 'smooth'
        });
        setShouldScrollToPurchase(false);
        return;
      }
      if (attempts < 30) {
        attempts += 1;
        frameId = requestAnimationFrame(scrollWhenReady);
      }
    };
    frameId = requestAnimationFrame(scrollWhenReady);
    return () => cancelAnimationFrame(frameId);
  }, [isBelowFoldReady, shouldScrollToPurchase]);
  const handlePurchaseRequest = () => {
    setShouldScrollToPurchase(true);
    setIsBelowFoldReady(true);
  };
  return <div className="min-h-screen bg-slate-950 text-slate-50 selection:bg-brand-500/30" data-id="element-0">
      <main data-id="element-1">
        <Hero onPurchaseRequest={handlePurchaseRequest} data-id="element-2" />
        {isBelowFoldReady && <Suspense fallback={null} data-id="element-3">
            <BelowFold data-id="element-4" />
          </Suspense>}
      </main>
    </div>;
}